import { render, staticRenderFns } from "./ProductMoveToOtherDepartment.vue?vue&type=template&id=264a4346"
import script from "./ProductMoveToOtherDepartment.vue?vue&type=script&lang=js"
export * from "./ProductMoveToOtherDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports